import { render, staticRenderFns } from "./salesDetail.vue?vue&type=template&id=5f48581c&scoped=true"
import script from "./salesDetail.vue?vue&type=script&lang=js"
export * from "./salesDetail.vue?vue&type=script&lang=js"
import style0 from "./salesDetail.vue?vue&type=style&index=0&id=5f48581c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f48581c",
  null
  
)

export default component.exports